import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '../../shared/services/rest.service';
import { SessionService } from '../../shared/services/session.service';
import { MessageService } from '../../shared/message.service';
import Swal from 'sweetalert2';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ValidacaoComponent } from '../veiculo/orcamento/validacao/validacao.component';

@Component({
  selector: 'app-login-siga',
  templateUrl: './login-siga.component.html',
  styleUrls: ['./login-siga.component.css']
})
export class LoginSigaComponent implements OnInit {
  token:string="";
  protocolo:string="";
  bsModalRef: BsModalRef;
  constructor(private route: ActivatedRoute,
      private router: Router,
      //private loginService: LoginService,
      private sessionService: SessionService,
      private rest: RestService,
      private modalService: BsModalService,
      private info: MessageService) { }

  ngOnInit(): void {
      //get dados auto login
      this.route.params.subscribe(params => {
      if (params['token'] !== undefined) {
        this.token = params['token'];
      }
      if (params['protocolo'] !== undefined) {
        this.protocolo = params['protocolo'];
      }
    });
    //token não informado
    if(!(this.token?.length>0)){
      this.info.showErro('Nenhum token informado');
      return;
    }
    
    //current session
    let userSession = this.sessionService.getUserSession();
    //Novo token? ===============================================
    if(userSession.tokenSiga!=this.token){   
      this.rest.getTokenSiga(this.token).subscribe(async (result: any) => {
      //store token in session
      userSession.tokenSiga=this.token;
      //sucesso?
      if(result?.dadosAcesso?.status=="success"){
        let dados = result?.dadosAcesso?.data[0];
        if(dados){  
          //set current SecretKey  
          userSession.secretKey = dados.controlAccess?.secretKey;
          if(dados.validarToken=='SIM'){
            this.info.showErro('Login pendente de validação no token');
            return ;
          }
          //parse dados in session        
          userSession = this.sessionService.parseDadosLoginRest(userSession, userSession.secretKey, dados);
          await this.sessionService.setCurrentSession(userSession); 
          this.openModal();    
        }
      }else{
         if(result==null){
          this.info.showErro("Nenhum dado retornado, retorno inválido: REST");
          this.sessionService.clear();
          return;
         }
         
      }
    }
    , error => {
      this.info.showErro(error.message)
      console.error(error);
      return;
      }
      );
    }//final new token
    else{
      this.openModal();   
    }

    //to home page
    //this.router.navigate(['/orcamento/todos']);

  }
  openModal(){
      if(this.protocolo){
      const initialState = {
        protocolo: this.protocolo
      };
      this.bsModalRef = this.modalService.show(ValidacaoComponent, {
         backdrop: true,
         ignoreBackdropClick:true,
         initialState, class: 'modal-dialog-centered modal-xl modal-validacao' });
    }
  }

}
